"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("util");
var potrace = require('potrace');
exports.potraceTrace = util_1.promisify(potrace.trace.bind(potrace));
exports.potracePosterize = util_1.promisify(potrace.posterize.bind(potrace));
//# sourceMappingURL=potrace.js.map